import { render, staticRenderFns } from "./MenuDevicePermissions.vue?vue&type=template&id=e468a290"
import script from "./MenuDevicePermissions.vue?vue&type=script&lang=js"
export * from "./MenuDevicePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports